import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { useApp } from '../context/AppContext';
import { startNativeAuthLinks } from '../native/authLinks';

export default function NativeAuthLinkListener() {
  const navigate = useNavigate();
  const { isAuthLoading } = useApp();
  const loading = useRef(isAuthLoading);
  const navigateRef = useRef(navigate);
  const pending = useRef<string | null>(null);
  loading.current = isAuthLoading;
  navigateRef.current = navigate;

  useEffect(() => startNativeAuthLinks(route => {
    if (loading.current) pending.current = route;
    else navigateRef.current(route, { replace: true });
    // BrowserRouter's navigate identity changes with location. Re-registering
    // would reread a stale launch token on every subsequent navigation.
  }), []);

  useEffect(() => {
    if (!isAuthLoading && pending.current) {
      const route = pending.current;
      pending.current = null;
      navigate(route, { replace: true });
    }
  }, [isAuthLoading, navigate]);
  return null;
}
